__turbopack_context__.v({
  "body": "ChangeTravelTimesSheet-module__qHt_0W__body",
  "bodyModal": "ChangeTravelTimesSheet-module__qHt_0W__bodyModal",
  "date": "ChangeTravelTimesSheet-module__qHt_0W__date",
  "footerModal": "ChangeTravelTimesSheet-module__qHt_0W__footerModal",
  "footerModalButton": "ChangeTravelTimesSheet-module__qHt_0W__footerModalButton",
  "header": "ChangeTravelTimesSheet-module__qHt_0W__header",
  "heading": "ChangeTravelTimesSheet-module__qHt_0W__heading",
  "options": "ChangeTravelTimesSheet-module__qHt_0W__options",
});
